import { Component, OnInit, Input } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'dmmp-embed',
  templateUrl: './embed.component.html'
})
export class EmbedComponent implements OnInit {

  @Input() src
  @Input() defaultClass
  @Input() type

  constructor() { }

  ngOnInit(): void {
  }

}
